import { useCallback } from 'react';

import { useQueryClient } from '@tanstack/react-query';

import { invalidateClusterDashboardQueries } from '@cast/features-cluster-shared';
import { useCluster } from '@cast/shared-cluster-context-data-access';
import { useAssignCredentialsDialogV2 } from '@cast/split-me/hooks/dialogs';

export const useInstallClusterAgentDialog = () => {
  const queryClient = useQueryClient();
  const { cluster } = useCluster();

  const { openAssignCredentialsDialog } = useAssignCredentialsDialogV2({
    shouldNavigateOnSuccess: false,
    onSuccess: () => {
      void invalidateClusterDashboardQueries(queryClient, cluster.id);
    },
  });

  const openInstallClusterAgentDialog = useCallback(() => {
    openAssignCredentialsDialog({ cluster });
  }, [cluster, openAssignCredentialsDialog]);

  return { openInstallClusterAgentDialog };
};
